import classnames from 'classnames'
import React, { useEffect } from 'react'
import { AD_BANNER_WIDTH, AD_RECTANGLE_WIDTH } from '../../store/ad/ad.constants'
import {
  AdDesktopExpenseReportBanner,
  AdDesktopExpenseReportRectangleLeft,
  AdDesktopExpenseReportRectangleRight,
} from '../advertising/InlineDesktopAdBanner'
import s from './ExpenseReport.less'
import ExpenseReportComputedItinerarySection from './ExpenseReportComputedItinerarySection'
import ExpenseReportCostSection from './ExpenseReportCostSection'
import ExpenseReportHeader from './ExpenseReportHeader'
import ExpenseReportSummarySection from './ExpenseReportSummarySection'
import ExpenseReportVehicleSection from './ExpenseReportVehicleSection'

const AD_MARGIN = 20
const MAX_WIDTH_FOR_ALL_ADS = AD_BANNER_WIDTH + 2 * (AD_RECTANGLE_WIDTH + AD_MARGIN)

const ExpenseReport = () => {
  const shouldDisplayLeftAd = (window?.innerWidth ?? 0) >= MAX_WIDTH_FOR_ALL_ADS

  useEffect(() => {
    document.body.classList.add('scrollable')
    return () => document.body.classList.remove('scrollable')
  }, [])

  return (
    <>
      <div className={s.container}>
        <ExpenseReportHeader />
        <div className={s.main}>
          {shouldDisplayLeftAd && <AdDesktopExpenseReportRectangleLeft className={classnames(s.ad, s.adPlaceHolder)} />}
          <div className={s.expense}>
            <AdDesktopExpenseReportBanner className={s.ad} />
            <ExpenseReportVehicleSection />
            <hr />
            <ExpenseReportComputedItinerarySection />
            <hr />
            <ExpenseReportSummarySection />
            <hr />
            <ExpenseReportCostSection />
          </div>
          <AdDesktopExpenseReportRectangleRight className={classnames(s.ad, s.adPlaceHolder)} />
        </div>
      </div>
    </>
  )
}

export default ExpenseReport
